import { render, staticRenderFns } from "./WithoutMovement.vue?vue&type=template&id=780de954"
import script from "./WithoutMovement.vue?vue&type=script&lang=js"
export * from "./WithoutMovement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports